import {DomainObject} from 'shared/store';
import {computed, observable, makeObservable} from 'mobx';
import moment from 'moment';

class TimeOffPeriod extends DomainObject {
  startDate = null;
  endDate = null;
  allDay = false;
  employeeId = null;
  typeName = null;

  constructor(other) {
    super();

    makeObservable(this, {
      startDate: observable,
      endDate: observable,
      allDay: observable,
      employeeId: observable,
      typeName: observable,
      startsAt: computed,
      endsAt: computed,
      lastDay: computed
    });

    this.merge(other);
  }

  get startsAt() {
    return this.allDay ? moment(this.startDate, 'YYYY-MM-DD') : moment(this.startDate);
  }

  get endsAt() {
    return this.allDay ? moment(this.endDate, 'YYYY-MM-DD') : moment(this.endDate);
  }

  get lastDay() {
    return this.allDay ? this.endsAt.clone().subtract(1, 'day') : this.startsAt;
  }

  coversDay(day) {
    return day.isBetween(this.startsAt, this.lastDay, 'day', '[]');
  }
}

export default TimeOffPeriod;
